import store from '@/store'
import config from '@/config/defaultSettings'

export const domTitle = config.title

/** 不含未读前缀的基础标题，如「兑换审核 - 管理系统」 */
let baseDocumentTitle = config.title || ''

function stripNoticePrefix (title) {
  return String(title || '').replace(/^\(\d+\)\s+/, '')
}

function resolveNoticeCount () {
  try {
    const n = Number(store.getters.pendingNoticeTotal)
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
  } catch (e) {
    return 0
  }
}

function applyWechatTitleHack () {
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

/** 按铃铛未读数刷新标签页标题，格式：(7) 兑换审核 - 管理系统 */
export function applyDocumentTitle () {
  const count = resolveNoticeCount()
  const next = count > 0 ? `(${count}) ${baseDocumentTitle}` : baseDocumentTitle
  if (document.title === next) {
    return
  }
  document.title = next
  applyWechatTitleHack()
}

export const setDocumentTitle = function (title) {
  baseDocumentTitle = stripNoticePrefix(title) || config.title || ''
  applyDocumentTitle()
}

/** 未读数变化时调用，保留当前页面基础标题 */
export function refreshDocumentTitle () {
  applyDocumentTitle()
}
